import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import ImageUploader from "../../../../components/inputs/imageUploader/ImageUploader";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchUserImages } from "../../../../features/images/userImages/userImagesSlice";
import styles from "./userImages.module.css";
import UserOneImage from "./userOneImage/UserOneImage";

const UserImages = () => {
  const dispatch = useDispatch();

  const {
    fetchStatus,
    deleteStatus,
    list: userImages,
    uploadStatus,
  } = useSelector((state) => state.userImages);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchUserImages());
    }
  }, [dispatch, fetchStatus]);

  if (
    fetchStatus === "loading" ||
    deleteStatus === "loading" ||
    uploadStatus === "loading"
  ) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textTitle">جميع صور اللاعبين</TextWrapper>
        <div className={styles.imageUploaderWrapper}>
          <ImageUploader tag={"user"} label="رفع صورة جديدة" />
        </div>
      </div>
      <div className={styles.allImagesWrapper}>
        <DisplayContainer className={styles.imagesDisplay}>
          {userImages.map((item) => {
            return (
              <UserOneImage
                key={item._id}
                path={item.path}
                name={item.name}
                id={item._id}
              />
            );
          })}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default UserImages;
